import type { MailboxInfo } from "owa-client-types";
import type { AgentType } from "owa-bizchat-types";
import { isDefaultCalendarAgentEnabled } from "owa-copilot-settings-utils/lib/utils/isDefaultCalendarAgentEnabled";
import { isCalendarAgentHelixEnabled } from "owa-copilot-settings-utils/lib/utils/isCalendarAgentHelixEnabled";

/**
 * Returns the default Calendar agent type based on active flights,
 * or undefined when the default calendar agent feature is disabled.
 *
 * This is the single control point for all calendar agent flight gating:
 * - cal-copilot-default-calendar-agent: enables the default calendar agent (legacy TimeAdvisor)
 * - cal-copilot-default-calendar-agent-helix: switches to CalendarAgentHelix BuiltInAgent
 *
 * Callers should not check these flights individually.
 */
export function getDefaultCalendarAgentType(mailboxInfo: MailboxInfo): AgentType | undefined {
    if (!isDefaultCalendarAgentEnabled(mailboxInfo)) {
        return undefined;
    }
    return isCalendarAgentHelixEnabled(mailboxInfo) ? "CalendarAgentHelix" : "TimeAdvisor";
}
